<template>
  <div class="vx-row">

    <div class="vx-col w-full">
      <vx-card>

        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form id="popup" @submit.prevent="handleSubmit(onClickUpdatePotentialCustomer)" autocomplete="off">

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <vs-alert color="dark" active="false">
                  <small>Company Name: &nbsp;&nbsp;</small> {{form.company_name}}
                </vs-alert>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <vs-alert color="dark" active="false">
                  <small>Potential Customer Code: &nbsp;&nbsp;</small> {{form.potential_customer_code}}
                </vs-alert>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                  <small class="label">First Name</small>
                  <vs-input v-model="form.first_name" name="first_name" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col  md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                  <small class="label">Last Name</small>
                  <vs-input v-model="form.last_name" class="w-full" name="last_name" type="text" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                  <small class="label">Email</small>
                  <vs-input v-model="form.email" name="email" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="industry_sector" name="industry_sector" rules="required" v-slot="{ errors }">
                  <small class="label">Industry Sector</small>
                  <v-select v-on:input="onChangeIndustrySector" :clearable="false" name="industry_sector" placeholder=""
                            label="name" v-model="form.industry_sector" :reduce="option => option.name"
                            :options="industrySectors" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.name}} </span>
                    </template>
                  </v-select>

                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="industry_sub_sector" name="industry_sub_sector" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Industry Sub Sector</small>
                  <v-select :clearable="false" name="industry_sub_sector" placeholder="" label="name"
                            v-model="form.industry_sub_sector" :reduce="option => option.name"
                            :options="industrySubSectors" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.name}} </span>
                    </template>
                    <template #no-options="{ search, searching, loading }">
                      Please select Industry Sector first!
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-1/2">
                <ValidationProvider vid="contact_country_code" name="contact_country_code" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Country Code</small>
                  <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code"
                            v-model="form.contact_country_code" :reduce="option => option.isd_code"
                            :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.isd_code}} - {{option.name}} </span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-1/2">
                <ValidationProvider vid="contact_number" name="contact_number" rules="required|tel|min_tel|max_tel"
                                    v-slot="{ errors }">
                  <small class="label">Contact Number</small>
                  <vs-input v-model="form.contact_number" class="w-full" name="contact_number" type="text" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col  md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                  <small class="label">Address Line 1</small>
                  <vs-input v-model="form.line1" class="w-full" name="line1" type="text" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                  <small class="label">Address Line 2</small>
                  <vs-input v-model="form.line2" name="line2" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col  md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                  <small class="label">Address Line 3</small>
                  <vs-input v-model="form.line3" class="w-full" name="line3" type="text" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                  <small class="label">Name of Town / State</small>
                  <vs-input v-model="form.town_state" name="town_state" class="w-full required" label=""/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                  <small class="label">Postal code</small>
                  <vs-input type="text" v-model="form.post_code" name="post_code" class="w-full" :danger="!!errors[0]"
                            :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                  <small class="label">Country</small>
                  <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder="" label="name"
                            v-model="form.country" :reduce="option => option.name" :options="countryCodes"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.name}} </span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider  vid="type_of_potential_customer" name="type_of_potential_customer" rules="required" v-slot="{ errors }">
                  <small class="label">Customer Type</small>
                  <v-select  :clearable="false" name="type_of_potential_customer" placeholder="" label="name" v-model="form.type_of_potential_customer" :reduce="option => option.value" :options="typeOfCustomers" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                    <template v-slot:option="option">
                      <span>{{option.name}} </span>
                    </template>
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                  <small class="label">Additional Information</small>
                  <vs-textarea class="mb-0" v-model="form.additional_information" height="100px" />
                  <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>


            <!-- Save & Reset Button -->
            <div class="flex flex-wrap items-center justify-end mt-8">
              <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
              <vs-button @click="form = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
            </div>
          </form>
        </ValidationObserver>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const CustomerRepository = RepositoryFactory.get('customer')

  export default {
    name: "PotentialCustomerProfileDetailsView",
    data() {
      return {
        form: {},
        potentialCustomerId: null,
        countryCodes: [],
        industrySectors: [],
        industrySubSectors: [],
        typeOfCustomers: [
          {name: 'Prospect', value: 'prospect'},
          {name: 'Suspect', value: 'suspect'},
          {name: 'Fan', value: 'fan'},
          {name: 'Customer', value: 'customer'}
        ]
      }
    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      async getPotentialCustomerDetails() {
          this.$vs.loading();
          try {
            const {data} = (await CustomerRepository.getPotentialCustomerDetails(this.potentialCustomerId)).data
            this.form = data
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
      },
      async loadIndustrySectors() {
        await this.$vs.loading({container: '#popup', scale: 0.50});
        const {data} =  (await CustomerRepository.getIndustrySectors()).data
        this.industrySectors =  data
        await this.$vs.loading.close('#popup > .con-vs-loading')
      },
      async loadCountrCode() {
        await this.$vs.loading({container: '#popup', scale: 0.50});
        const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
        this.countryCodes =  data
        await this.$vs.loading.close('#popup > .con-vs-loading')
      },
      async onChangeIndustrySector(name) {
        await this.$vs.loading({
          container: '#popup',
          scale: 0.50
        });
        this.form.industry_sub_sector = null
        let obj = this.industrySectors.find((m) => m.name === name)
        const {data} =  (await CustomerRepository.getIndustrySubSectors(obj.id, '')).data
        this.industrySubSectors =  data
        await this.$vs.loading.close('#popup > .con-vs-loading')
      },
      async initialIndustrySubSectorList() {
        await this.$vs.loading({
          container: '#popup',
          scale: 0.50
        });
        let obj = this.industrySectors.find((m) => m.name === this.form.industry_sector)
        const {data} =  (await CustomerRepository.getIndustrySubSectors(obj.id, '')).data
        this.industrySubSectors =  data
        await this.$vs.loading.close('#popup > .con-vs-loading')
      },
      async onClickUpdatePotentialCustomer() {
        const vue = this;
        await this.$vs.loading({
          container: '#popup',
          scale: 0.50
        });
        try {
          await CustomerRepository.updatePotentialCustomerDetails(this.potentialCustomerId, this.form)
          this.showSuccessMessage('Customer updated successfully')
        }catch (e) {
          this.$vs.loading.close()
          this.convertAndNotifyError(e)
        }
        await this.$vs.loading.close('#popup > .con-vs-loading')
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
    },
    async mounted() {
      this.potentialCustomerId = this.$route.params.id
      await this.getPotentialCustomerDetails()
      await this.loadIndustrySectors()
      await this.loadCountrCode()
      await this.initialIndustrySubSectorList()
    }
  }
</script>

<style scoped>

</style>
